<template>
  <div clas="flex justify-center content-center">
  <div :class="'float-left mr-2 badge badge-' + (type == 'RETRAIT' ? 'danger' : 'success' )">
    <arrow-down-icon v-if="type == 'RETRAIT'" />
    <arrow-up-icon v-else />
  </div>
  <div class="payment-type">
    <span v-if="type == 'RETRAIT'">{{ $t('TRANSACTIONS_DPA.RETRAIT') }} </span>
    <span v-else> {{ $t('TRANSACTIONS_DPA.DEPOT') }} </span>
  </div>
</div>
</template>

<script>
import ArrowDownIcon from "../Icons/ArrowDownIcon.vue";
import ArrowUpIcon from "../Icons/ArrowUpIcon.vue";
import { DEPOT, RETRAIT } from "@/constants/payments";

export default {
  name: "InOutBadge",
  components: {
    ArrowUpIcon,
    ArrowDownIcon,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    badgeType() {
      console.log(this.type)
      switch (this.type) {
        case DEPOT:
          return "success";
        case RETRAIT:
          return "danger";
        default:
          return "default";
      }
    },
  },
};
</script>
